module.exports = __webpack_public_path__ + "img/saving-pig.39d19c4.svg";